import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MapPin, ArrowRight } from 'lucide-react';

interface Props {
  onClick?: () => void;
}

const PetFriendlyPlacesBanner = ({ onClick }: Props) => {
  const { t } = useTranslation();
  return (
    <Link
      to="/places"
      onClick={onClick}
      className="group flex items-center justify-between bg-gradient-to-r from-emerald-500 to-teal-500 rounded-xl p-4 hover:shadow-lg transition-all text-white"
    >
      <div className="flex items-center gap-3">
        <MapPin className="h-6 w-6 shrink-0" />
        <div>
          <div className="font-semibold text-base">{t('places.title', 'Pet Friendly Places')}</div>
          <div className="text-sm text-white/85">
            {t('places.bannerSubtitle', 'Discover dog parks, cafés, shops & restaurants near you')}
          </div>
        </div>
      </div>
      <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
    </Link>
  );
};

export default PetFriendlyPlacesBanner;
